import './print.less'
import PrintTitlePage from './components/pageTitle'
import React from 'react'

const PrintCover = ({ date }: { date: string }): React.ReactElement => {
  return <PrintTitlePage date={date} />
}

export default PrintCover
